import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResponseNet } from 'src/app/model/ResponseNet.model';
import { jwtDecode, ResponseUser, User } from 'src/app/model/User.model';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';
import { UserService, UserToken } from 'src/app/services/user.service';
import { API } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  email: string;
  senha: string;
  jwt_decode: UserToken;
  user: ResponseUser = new ResponseUser();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private ajax: AjaxService,
    private util: UtilService,
    private auth: UserService,
    private userService: UserService,
  ) {
    this.user.user = new User();
    this.user.token = "";
  }

  ngOnInit() {
    this.email = '';
    this.senha = '';
    this.route.queryParams.subscribe(params => {
      if (params['email']) {
        this.email = params['email'];
      }
      if (params['senha']) {
        this.senha = params['senha'];
      }
    });
  }

  login() {
    this.util.showLoading();
    var url = API + 'Login/Login?login=' + this.email + '&senha=' + this.senha;
    this.ajax.get(url)
      .subscribe((response: ResponseNet) => {
        this.util.closeLoading();
        
        debugger
        this.jwt_decode = this.util.getDecodedAccessToken(response.data);
        this.jwt_decode.token = response.data;
        /*this.user.user.nome = this.jwt_decode.nameid;
        this.user.token = response.data.token;
        this.user.user.perfil = response.data.identificador;*/

        // Salvar dados no localStorage usando o UserService
        this.userService.saveUserData(this.jwt_decode);
        
        // Manter a lógica existente do AuthService
        //this.auth.setUser(this.user);
        this.util.toasterShowSuccess("Sucesso", "Bem Vindo " + this.jwt_decode.User.Name);
        this.router.navigate(['/home']);

      }, err => {
        this.util.closeLoading();
        this.util.toasterShowError("Atenção", "Usuário ou Senha inválidos");
      });
  }

  irParaCadastro() {
    this.router.navigate(['/cliente']);
  }
}
